document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector(".ns_form");
    const submitButton = document.getElementById("submitButton");
    let formCont = document.getElementsByClassName("nsCustomForm")[0];
    let formId = form.className;

    form.addEventListener("submit", (e) => {
        e.preventDefault();

        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = "Validating...";
        }

        grecaptcha.ready(function () {
            grecaptcha
                .execute("6Lelt8orAAAAAM8uwFDp_03tVvZTNcgHEZB_FAjI", {
                    action: "submit",
                })
                .then(function (token) {

                    // console.log("this is the token that is failing currently ", token)
                    // token = "invalid_token_for_testing";
                    // First validate reCAPTCHA on server
                    fetch("https://formscabinetstogo.com/recaptcha-validate.php", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ token: token }),
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            // console.log("data.success ", data.success);
                            if (data.success) {
                                // console.log(
                                //     "reCAPTCHA validation successful, score:",
                                //     data.score,
                                // );
                                // Add token to form
                                addTokenToForm(formId, token);

                                let isValid = false;
                                // //  console.log("Validating form with etcStoreValidate");
                                isValid = formValidation(form);
                                if (isValid) {
                                    // Set the action and submit
                                    // console.log('is valid')
                                    // submitBackupData(form);
                                    submitFormById(form, submitButton, formCont,e)

                                } else {
                                    // console.log('is NOT valid')
                                //     // Re-enable submit button if validation fails
                                    if (submitButton) {
                                        submitButton.disabled = false;
                                        submitButton.textContent = "Submit";
                                    }
                                }

                            }
                        })
                        .then(e =>{
                            // console.log('submit completed ---------------')

                        });;
                });
        })
    });

});

function addTokenToForm(formId, token) {
  let form = document.getElementsByClassName(formId)[0];
  let existingToken = form.querySelector('input[name="recaptcha_token"]') || null;

  if (existingToken) {
    existingToken.remove();
  }

  let tokenInput = document.createElement("input");
  tokenInput.type = "hidden";
  tokenInput.name = "recaptcha_token";
  tokenInput.value = token;
  tokenInput.required = true;

//   console.log("tokenInput ", tokenInput);
  form.appendChild(tokenInput);
}
function submitBackupData(form) {
    // Get form data from the form ID
    const formElement = form;

    if (!formElement) {
        console.error(`Form with ID ${form.className} not found`);
        return;
    }

    // Create FormData from the form element
    var formData = new FormData(formElement);
    console.log('form data', formData)
    // Optional: Log to verify data is captured
    console.log("Sending backup data for form:", form.className);
    for (let pair of formData.entries()) {
        // console.log(pair[0] + ': ' + pair[1]);
    }
    fetch('https://formscabinetstogo.com/bot_form.php', {
        method: 'POST',
        data: formData,
    })
    .then(response => response.text())
    .then(data => console.log('Success:', data))
    .catch(error => console.log('Error:', error));
}
function submitFormById(form, submitButton, formCont,e) {
    // console.log("------ submitting -----------")
    // const form = document.querySelector('.ns_form');
    // const submitButton = document.getElementById('submitButton');
    // let formCont = document.getElementsByClassName('nsCustomForm')[0]

    if (!form) return;

        e.preventDefault();

        const actionUrl = 'https://4124572.extforms.netsuite.com/app/site/crm/externalleadpage.nl';
        form.setAttribute('action', actionUrl);
        form.setAttribute('method', 'post');
        form.setAttribute('target', 'formLoadingFrame');

        const iframe = document.querySelector('iframe[name="formLoadingFrame"]');
        if (iframe) {
            iframe.style.display = 'block';
            iframe.style.visibility = 'visible';
            iframe.style.height = '400px';
            iframe.style.width = '100%';

            form.style.display = 'none';

            const loadingMsg = document.createElement('div');
            loadingMsg.className = 'form-loading-message';
            loadingMsg.textContent = 'Submitting...';
            form.parentNode.insertBefore(loadingMsg, iframe);
            // console.log('iframe ', iframe)
        }
        // Remove the event listener to prevent loop
        // let how = document.querySelector('#custentity18Select').value
        // form.querySelector("#custentity18Select").value
        // console.log('form element ', new FormData(form))



        // const newForm = form.cloneNode(true);
        // console.log('new form ', newForm)
        // form.parentNode.replaceChild(newForm, form);
        formCont.style.height = '300px'
        if (formCont) {
            const y = formCont.getBoundingClientRect().top + window.scrollY - 150;
            window.scrollTo({ top: y, behavior: "smooth" });
        } else {
            console.warn(".newCustomForm not found");
        }

        form.submit();
        submitButton.disabled = false;
    }
function formValidation(xf){
    // console.log("xf ",xf)
    var vFirst = xf["firstname"];
    var vLast = xf["lastname"];
    var vPhone = xf["phone"];
    var vEmail = xf["email"];
    var vZip = xf["zipcode"];
    var vCity = xf["city"];
    var vAddress = xf["address"];
    var vState = xf["state"];
    var vCatalog = xf["custentity_ctg_web_catalog_type"];
    var vCompany = xf["companyname"];
    var vHeard = xf["custentity18"];
    var vBestTime = xf['custentity_timeandday']
// console.log(vFirst, vLast, vAddress, vCity);

    validateField(vFirst)
    validateField(vLast)
    validateField(vAddress)
    validateField(vCity)

    let phoneValue = vPhone.value
    if (phoneValue != null || phoneValue != "") {
        const re = /^(\(\d{3}\)\s*\d{3}-\d{4}|\d{10}|\d{3}-\d{3}-\d{4})$/;
        let testRes = re.test(phoneValue);
        if (testRes) {
            vPhone.classList.remove("failed");
        } else {
            vPhone.classList.add("failed");
            return false
        }
    }
    let emailValue = vEmail.value
    if (emailValue != null || emailValue != '') {
        let isValid =  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
        if (isValid) {
            vEmail.classList.remove("failed");
        } else {
            vEmail.classList.add("failed");
            return false
        }
    }
    let zipValue = vZip.value
    if (zipValue != null || zipValue != '') {
        let isValid = /^[0-9]{5}(?:-[0-9]{4})?$/.test(zipValue);
        if (isValid) {
            vZip.classList.remove("failed");
        } else {
            vZip.classList.add("failed");
            return false
        }
    }
    // if(vHeard){
    //     let heardValue = vHeard.value
    //     if (heardValue === '') {
    //         vHeard.classList.add("failed");
    //         alert("Please select how you heard about us.")
    //         return false
    //     } else {
    //         vHeard.classList.remove("failed");
    //     }
    // }
    if(vBestTime){
        sanitize(vBestTime)
    }

  // ======== More Product Information Form =============
  // ============= INTERESTED PRODUCTS ==================

 if (xf.getElementsByClassName("productsType")[0] != null) {
    const productTypeInput = xf.querySelector('.productsType');
    const allProductCheckboxes = xf.querySelectorAll('.checkboxList.typeOfProduct input[type="checkbox"]');
    let checkedValues = [];
    allProductCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
            checkedValues.push(checkbox.value);
        }
    });
    if (checkedValues.length > 0) {
        productTypeInput.value = checkedValues.join(',');
    } else {
        productTypeInput.value = "Not Specified"; 
  }
}

  // ======================== Product Type ==========================
  if (xf.getElementsByClassName("projectValue")[0] != null) {
    const projectTypeInput = xf.querySelector('.projectValue');
    const allProjectCheckboxes = xf.querySelectorAll('.checkboxList.kindOfProject input[type="checkbox"]');
    let checkedValues = [];
    allProjectCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
            checkedValues.push(checkbox.value);
        }
    });
    if (checkedValues.length > 0) {
        projectTypeInput.value = checkedValues.join(',');
    } else {
        projectTypeInput.value = "Not Specified";
    }
  }
  // =========================== Project Timeline =======================================
  if (xf.querySelector('input[name="custentity_timeline"]')) {
    let timelineSelect = xf.querySelector(
      'input[name="custentity_timeline"]:checked'
    );
    // console.log('timeline select ',timelineSelect)
    // console.log('timeline select typeof', typeof timelineSelect)
    // let hiddenTimeline = xf.querySelector(".noneSelected");
    // if (timelineSelect) {
    //   hiddenTimeline.checked == false;
    // } else {
    //   hiddenTimeline.checked == true;
    // }
  }

  // =========================== Pro Install      =======================================
  if (xf.querySelector('input[name="custentity_install"]')) {
    let professionalSelected = xf.querySelector(
      'input[name="custentity_install"]:checked'
    );
    let professionalHidden = xf.querySelector(".noneSelectedProfessional");
    if (professionalSelected) {
      professionalHidden.checked == false;
    } else {
      console.log("made it to the proffesional install");
      professionalHidden.checked == true;
    }
  }

    return true
}
const sanitizer = new Sanitizer();
sanitizer.removeUnsafe()
function sanitize(valueDiv){
    let value = valueDiv.value
    const scratch = document.createElement('div');
    scratch.setHTML(value, { sanitizer });
    let clean = scratch.innerHTML
    valueDiv.value = clean.trim()
    // console.log("valueDiv ", valueDiv.value)
}

function validateField(item){
    if(item.value != ''){
        sanitize(item)
    }
    if(item.value == ''){
        item.classList.add("failed");
        return false
    }else{
        item.classList.remove("failed"); 
    }
}